"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.agent.speaking': 'L\'agente sta parlando',
    'conversation.agent.thinking': 'L\'agente sta pensando...',
    'conversation.agent.demo': 'Demo Agente Vocale',
    'conversation.agent.demo.description': 'Conversazione vocale interattiva con agenti IA utilizzando riconoscimento e sintesi vocale avanzati',
};
